import { useLazyQuery } from '@apollo/client';
import { Chip, TableColumnType, TableOrderByType } from '@elipssolution/harfang';
import { useCallback } from 'react';

import DomainSection from './domainSection/DomainSection';
import LinkIcon from '../../../../components/LinkIcon';
import SettingsTable from '../../../../components/SettingsTable';
import { useSettingsDialog } from '../../../../hooks/useSettingsDialog';
import { FETCH_DOMAINS, FetchDomainsType } from '../../../../src/api/domain';
import { DomainType } from '../../../../types/domain';

const columns: TableColumnType<DomainType>[] = [
	{
		field: 'name',
		key: 'name',
		sortable: true,
		title: 'Nom du domaine',
		width: 200,
	},
	{
		key: 'chip',
		flexGrow: 0,
		render: ({ isDefault }) => isDefault && <Chip label="Défaut" color="info" />,
		width: 150,
	},
	{
		key: 'navigate',
		flexGrow: 0,
		render: () => <LinkIcon />,
		width: 24,
	},
];

const DomainTable = () => {
	const { push } = useSettingsDialog();

	const [fetchDomains] = useLazyQuery<FetchDomainsType>(FETCH_DOMAINS);

	const dataSource = useCallback(
		async (
			limit: number,
			offset: number,
			search?: string,
			orderBy?: TableOrderByType<DomainType>,
		): Promise<{
			count: number;
			items: DomainType[];
		}> => {
			const { field, order } = orderBy || {};

			const { data, error } = await fetchDomains({
				variables: {
					...(orderBy && { orderBy: { field, order } }),
					page: {
						limit,
						offset,
					},
					search,
				},
			});

			if (error) {
				throw error;
			}

			const {
				domains: { count = 0, items = [] },
			} = data ?? {
				domains: {},
			};

			return {
				count,
				items,
			};
		},
		[fetchDomains],
	);

	const openDomainSection = (domain?: DomainType) => {
		push(<DomainSection domain={domain} />);
	};

	return (
		<SettingsTable dataSource={dataSource} onRowClick={openDomainSection} tableColumns={columns} title="Domaines" />
	);
};

export default DomainTable;
